import { render } from "./ImageHolder.vue?vue&type=template&id=c8de3792&ts=true"
import script from "./ImageHolder.vue?vue&type=script&lang=ts"
export * from "./ImageHolder.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__